import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const PromoCodeUsageLimitExceededModal = (props: AlertProps) => (
    <Alert
        {...props}
        title="Невозможно применить промокод"
        description="Лимит использования промокода исчерпан"
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
